// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606160850/js/" + chunkId + "." + {"44":"5dbb7bd1","225":"6b1ddbcd","481":"7f979bee","486":"47948172","770":"4f28a0f5"}[chunkId] + ".0.33255292956294236.chunk.js";
};